<template>
  <PmwAlertModal
    v-model="modalShow"
    title="Suas modificações serão salvas"
    icon="pmw-alert"
    confirmButtonText="Salvar e continuar"
    cancelButtonColor="grey-100"
    confirmButtonColor="blue-100"
    @alert-modal-cancel="$emit('close', $event)"
    @alert-modal-confirm="$emit('activate', $event)"
  >
    <template #text>
      Ao ativar, todas as edições da tarifa serão salvas.
    </template>
  </PmwAlertModal>
</template>

<script>
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

export default {
  name: 'ActivateRateModel',

  components: {
    PmwAlertModal
  },

  props: {
    showActivateModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modalShow: false
    }
  },

  watch: {
    showActivateModal(newVal) {
      this.modalShow = newVal
    }
  }
}
</script>
